module.exports = __webpack_public_path__ + "static/media/token.3a650163.png";